import { withAsyncLoading } from '../../Components/Templates/Loading/AsyncPageLoading/withAsyncPageLoading';

const LoadableMessagePage = withAsyncLoading(async () =>
    import('./MessagePage').then((res) => res.MessagePage)
);

export { LoadableMessagePage };
